import Config from '@configs/Environments';
import useAxios from 'axios-hooks';
import useMockServer from './useMockServer';

const path = Config.API_END_POINT + '/entry/relits/';

const useAllListData = (id:any, timestamp:number): any => {

    const pathEnd = '/status' + (useMockServer ? '' : '?timestamp=' + timestamp);

    const [{ data, loading, error }] = useAxios(`${path}${id}${pathEnd}`, { useCache: false });

    return { data, loading, error };
};

const useMessageStatus = (params: any): any => {
    const path = Config.API_END_POINT + '/entry/relit/message/status';
    const [{ data, loading, error }] = useAxios({
        url: path,
        method: 'POST',
        data: params,
    });

    return { data, loading, error };
};

const useOpenRequestStatus = {
    useAllListData,
    useMessageStatus
};

export default useOpenRequestStatus;